/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var VideoPlayIcon = createIcon("VideoPlayIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#767676';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    opacity: ".5",
    stroke: _color,
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 47.496c12.426 0 22.5-10.074 22.5-22.5S37.426 2.496 25 2.496 2.5 12.57 2.5 24.996s10.074 22.5 22.5 22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 32.226a3.272 3.272 0 005.424 2.462L35.5 25l-11.076-9.694A3.27 3.27 0 0019 17.768v14.458Z"
  })));
}, {
  "replaceColor": true
});